var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpringBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1600,
    height: 1600,
    viewBox: "0 0 1600 1600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6575_140295)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 1600,
    rx: 8,
    fill: "url(#paint0_linear_6575_140295)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1522.94 243.233H1317.54C1313.44 236.72 1311.08 229.012 1311.08 220.75C1311.08 197.392 1330.01 178.456 1353.36 178.456C1359.34 178.456 1365.02 179.695 1370.18 181.93C1381.83 163.725 1402.23 151.658 1425.45 151.658C1446.11 151.658 1464.53 161.211 1476.55 176.14C1480.92 174.612 1485.62 173.78 1490.52 173.78C1513.87 173.78 1532.81 192.717 1532.81 216.076C1532.81 226.414 1529.1 235.885 1522.94 243.233Z",
    fill: "#F9FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M407.82 316.859C408.295 316.353 408.757 315.835 409.207 315.306C409.429 315.83 409.662 316.348 409.906 316.859H479.163C481.542 311.878 482.873 306.302 482.873 300.416C482.873 279.282 465.708 262.15 444.535 262.15C433.619 262.15 423.769 266.703 416.786 274.011C410.982 257.678 395.366 245.98 377.013 245.98C362.352 245.98 349.437 253.445 341.876 264.773C335.326 259.562 327.027 256.448 317.999 256.448C296.826 256.448 279.662 273.58 279.662 294.712C279.662 302.966 282.28 310.609 286.732 316.859H407.82Z",
    fill: "#F9FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M595.051 568.835C451.816 570.315 262.808 416.727 -62.0507 650.06C-73.8638 746.053 -97.1947 940.697 -96.0134 951.33C-94.8321 961.963 1151.74 968.559 1774.88 970.528C1763.06 846.477 1709.61 589.808 1590.3 555.546C1441.16 512.719 1325.98 608.711 1188.65 608.711C1051.33 608.711 978.974 515.673 847.553 511.242C716.133 506.812 714.657 568.835 595.051 568.835Z",
    fill: "#C7B3E7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1086.52 454.847H1272.35C1276.05 448.954 1278.2 441.981 1278.2 434.507C1278.2 413.375 1261.07 396.243 1239.94 396.243C1234.53 396.243 1229.39 397.364 1224.73 399.386C1214.18 382.917 1195.73 372 1174.72 372C1156.03 372 1139.36 380.642 1128.49 394.149C1124.53 392.766 1120.28 392.014 1115.86 392.014C1094.72 392.014 1077.6 409.145 1077.6 430.279C1077.6 439.631 1080.95 448.2 1086.52 454.847Z",
    fill: "#F9FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.1277 766.728C88.1803 766.728 119.528 750.864 140.385 725.923C154.726 736.749 172.58 743.169 191.932 743.169C224.24 743.169 252.369 725.278 266.955 698.862C276.504 706.008 288.36 710.241 301.204 710.241C332.806 710.241 358.425 684.619 358.425 653.014C358.425 621.408 332.806 595.786 301.204 595.786C286.664 595.786 273.391 601.21 263.297 610.144C247.953 587.069 221.718 571.862 191.932 571.862C174.573 571.862 158.42 577.027 144.926 585.905C124.239 557.65 90.8261 539.301 53.1277 539.301C-9.66705 539.301 -60.5723 590.212 -60.5723 653.014C-60.5723 715.816 -9.66705 766.728 53.1277 766.728Z",
    fill: "#4DA462"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1161.44 775.559C675.914 584.974 487.007 581.658 -33.3135 722.524C-27.2373 919.187 -15.0849 1315.16 -15.0849 1325.77C-15.0849 1336.38 993.519 1321.35 1497.82 1312.51C1547.53 1197.06 1549.85 928.027 1161.44 775.559Z",
    fill: "#C1D761"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-160.92 715.844C-33.2417 717.364 318.785 745.031 705.468 843.537C423.765 958.056 -141.465 1187.4 -148.76 1188.61C-156.056 1189.83 -159.907 873.94 -160.92 715.844Z",
    fill: "#9CCB37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5576 757.088L112.502 947.81",
    stroke: "#91C02E",
    strokeWidth: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-18.209 768.777L55.7357 959.499",
    stroke: "#91C02E",
    strokeWidth: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.136 757.088L177.08 947.81",
    stroke: "#91C02E",
    strokeWidth: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.081 773.773L251.026 964.495",
    stroke: "#91C02E",
    strokeWidth: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.751 780.465L306.237 947.81",
    stroke: "#91C02E",
    strokeWidth: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.396 794.1L370.815 947.81",
    stroke: "#91C02E",
    strokeWidth: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.974 805.766L435.394 959.476",
    stroke: "#91C02E",
    strokeWidth: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1498.05 832.781C1476.87 851.737 1448.91 863.263 1418.25 863.263C1398.19 863.263 1379.28 858.325 1362.66 849.597C1342.31 886.619 1302.94 911.708 1257.71 911.708C1240.12 911.708 1223.42 907.913 1208.38 901.099C1186.46 925.681 1154.54 941.16 1119.02 941.16C1052.91 941.16 999.324 887.564 999.324 821.451C999.324 755.338 1052.91 701.743 1119.02 701.743C1136.61 701.743 1153.31 705.537 1168.35 712.351C1190.27 687.769 1222.18 672.29 1257.71 672.29C1277.78 672.29 1296.69 677.229 1313.3 685.956C1333.66 648.935 1373.03 623.846 1418.25 623.846C1448.91 623.846 1476.87 635.372 1498.05 654.327C1519.23 635.372 1547.19 623.846 1577.85 623.846C1643.95 623.846 1697.54 677.441 1697.54 743.554C1697.54 809.667 1643.95 863.263 1577.85 863.263C1547.19 863.263 1519.23 851.737 1498.05 832.781Z",
    fill: "#4DA462"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1602.21 851.551C1076.92 644.394 518.49 762.058 -54.8558 970.872C-76.9502 1115.05 -122.796 1408.39 -129.424 1428.28C-343.186 2069.64 2034.38 2374.87 1900.49 1333.81C1976.16 1242.11 2022.45 1017.28 1602.21 851.551Z",
    fill: "#B5E08C"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1077.49,
    cy: 813.558,
    rx: 11.6664,
    ry: 11.6678,
    fill: "#FBEF2F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1177.89,
    cy: 860.736,
    rx: 11.6664,
    ry: 11.6678,
    fill: "#FBEF2F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1439.3,
    cy: 1199.67,
    rx: 23.3309,
    ry: 23.3336,
    fill: "#FBEF2F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1462.64,
    cy: 976.633,
    rx: 23.3331,
    ry: 23.3359,
    fill: "#FBEF2F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1335.81,
    cy: 947.81,
    rx: 11.6664,
    ry: 11.6678,
    fill: "#FBEF2F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1374.51,
    cy: 849.066,
    rx: 11.6664,
    ry: 11.6678,
    fill: "#FBEF2F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1555.31,
    cy: 1131.51,
    rx: 11.6663,
    ry: 11.6677,
    fill: "#FBEF2F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1555.31,
    cy: 924.474,
    rx: 11.6664,
    ry: 11.6678,
    fill: "#FBEF2F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1038.19,
    cy: 959.478,
    rx: 11.6664,
    ry: 11.6678,
    fill: "#FBEF2F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 670.7,
    cy: 971.144,
    rx: 11.6664,
    ry: 11.6678,
    fill: "#FBEF2F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 551.388,
    cy: 856.962,
    rx: 13.9919,
    ry: 13.9936,
    fill: "#FBEF2F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 966.622,
    cy: 840.584,
    rx: 15.3542,
    ry: 15.3559,
    fill: "#FBEF2F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 776.533,
    cy: 908.209,
    rx: 15.3541,
    ry: 15.3559,
    fill: "#FBEF2F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 209.123,
    cy: 932.431,
    rx: 19.7973,
    ry: 19.7997,
    fill: "#FBEF2F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 168.722,
    cy: 1251.98,
    rx: 19.7973,
    ry: 19.7997,
    fill: "#FBEF2F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 75.5327,
    cy: 994.479,
    rx: 19.7973,
    ry: 19.7997,
    fill: "#FBEF2F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 309.396,
    cy: 1108.17,
    rx: 11.6664,
    ry: 11.6678,
    fill: "#FBEF2F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 482.873,
    cy: 1329.42,
    rx: 11.6664,
    ry: 11.6678,
    fill: "#FBEF2F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 410.44,
    cy: 889.474,
    rx: 11.6664,
    ry: 11.6678,
    fill: "#FBEF2F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 359.15,
    cy: 952.826,
    rx: 11.6664,
    ry: 11.6678,
    fill: "#FBEF2F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1219.02,
    cy: 1039.73,
    rx: 11.6664,
    ry: 11.6678,
    fill: "#FBEF2F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1242.85,
    cy: 1516.56,
    rx: 11.6664,
    ry: 11.6678,
    fill: "#FBEF2F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 978.287,
    cy: 1260.12,
    rx: 11.6664,
    ry: 11.6678,
    fill: "#FBEF2F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1308.56,
    cy: 669.917,
    rx: 54.0375,
    ry: 54.0438,
    fill: "#F8B9D4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1343.26,
    cy: 611.54,
    rx: 54.0375,
    ry: 54.0438,
    fill: "#F8B9D4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1348.17,
    cy: 699.045,
    rx: 37.0956,
    ry: 37.0999,
    fill: "#F8B9D4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1385.27,
    cy: 669.917,
    rx: 54.0375,
    ry: 54.0438,
    fill: "#F8B9D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1343.25 837.399V622.213",
    stroke: "#D78585",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1385.26 658.236L1343.25 706.758",
    stroke: "#D78585",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1308.56 638.377L1342.83 665.584",
    stroke: "#D78585",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1560.13,
    cy: 836.088,
    rx: 65.7037,
    ry: 65.7115,
    fill: "#F8B9D4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1602.32,
    cy: 765.109,
    rx: 51.0776,
    ry: 51.0836,
    fill: "#F8B9D4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1529.27,
    cy: 748.014,
    rx: 14.3812,
    ry: 14.3829,
    fill: "#F8B9D4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1608.29,
    cy: 871.506,
    rx: 45.1041,
    ry: 45.1094,
    fill: "#F8B9D4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1653.4,
    cy: 836.088,
    rx: 65.7037,
    ry: 65.7115,
    fill: "#F8B9D4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 228.921,
    cy: 722.589,
    rx: 79.9961,
    ry: 80.0055,
    fill: "#F8B9D4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 280.283,
    cy: 636.17,
    rx: 79.9961,
    ry: 80.0055,
    fill: "#F8B9D4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 287.562,
    cy: 765.711,
    rx: 54.9155,
    ry: 54.922,
    fill: "#F8B9D4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 342.478,
    cy: 722.589,
    rx: 79.9961,
    ry: 80.0055,
    fill: "#F8B9D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.28 970.529V651.971",
    stroke: "#D78585",
    strokeWidth: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.477 705.299L280.28 777.129",
    stroke: "#D78585",
    strokeWidth: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.921 675.9L279.662 716.177",
    stroke: "#D78585",
    strokeWidth: 18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.52,
    cy: 712.874,
    r: 24.0266,
    fill: "#F4ADCB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.732,
    cy: 630.824,
    r: 18.0639,
    fill: "#F4ADCB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281.861,
    cy: 598.362,
    r: 12.7365,
    fill: "#F4ADCB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 380.709,
    cy: 730.939,
    r: 18.0639,
    fill: "#F4ADCB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 242.709,
    cy: 761.3,
    r: 18.0639,
    fill: "#F4ADCB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322.737,
    cy: 640.45,
    r: 24.0266,
    fill: "#FFC5DE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1538.91,
    cy: 843.425,
    r: 24.0266,
    fill: "#F4ADCB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1582.12,
    cy: 761.375,
    r: 18.0639,
    fill: "#F4ADCB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1579.1,
    cy: 891.851,
    r: 18.0639,
    fill: "#F4ADCB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1273.46,
    cy: 666.531,
    r: 18.937,
    fill: "#F4ADCB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1307.52,
    cy: 601.86,
    r: 14.2374,
    fill: "#F4ADCB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1335.99,
    cy: 576.275,
    r: 10.0385,
    fill: "#F4ADCB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1413.9,
    cy: 680.767,
    r: 14.2374,
    fill: "#F4ADCB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1305.13,
    cy: 704.698,
    r: 14.2374,
    fill: "#F4ADCB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1368.21,
    cy: 609.449,
    r: 18.937,
    fill: "#FFC5DE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6575_140295",
    x1: 630.802,
    y1: -689.472,
    x2: 1379.2,
    y2: 163.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAFCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6EEFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6575_140295"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 1600,
    rx: 8,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpringBg);
export default __webpack_public_path__ + "static/media/spring_bg.f51e048526e7ba5d863f09f0dd32d342.svg";
export { ForwardRef as ReactComponent };